import {ReactNode} from 'react'
import cn from 'clsx'
import {Modal as AntdModal, ModalProps as AntdModalProps} from 'antd'

import './Modal.scss'
import {CloseIcon} from 'common/components'

interface ModalProps extends AntdModalProps {
  children: ReactNode
  narrow?: boolean
}

export default function Modal({children, narrow, width, ...props}: ModalProps) {
  return (
    <AntdModal
      {...props}
      destroyOnClose
      maskClosable={!!props.onCancel ? false : true}
      className={cn('Modal', narrow && 'Modal_narrow')}
      footer={null}
      closeIcon={!!props.onCancel ? <CloseIcon /> : <span></span>}
      width={width}
      style={{minWidth: width}}
    >
      {children}
    </AntdModal>
  )
}
